export const texts = {
  projectDescription:
    'Meta[Z] is the world’s very first on/offline integrated collectible and redeemable NFT marketplace platform. The collections consist of sneakers, artworks, music and other collectible items.',
};
